<div class="addtocart-wrapper full-height-number-input">
  <app-number-button-input
    id="subAmount"
    [formControl]="amountControl"
  ></app-number-button-input>
  <button (click)="clickAdd()" [disabled]="disabled">In den Warenkorb</button>
  <button [class.hidden]="subscriptionEnabled === false" class="abo" (click)="clickAbo()">Abo</button>
</div>
